import { isId } from '../resources/types';
import type { ReadingPosition } from './scrollPolicy';

const key = (accountId: string) => `hylo.chat.bookmarks.v1.${accountId}`;
function load(accountId: string): Record<string, ReadingPosition> {
  try {
    const raw: unknown = JSON.parse(localStorage.getItem(key(accountId)) ?? '{}');
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
    return Object.fromEntries(Object.entries(raw).slice(-100).filter(([id, p]: [string, ReadingPosition]) => isId(id) && p && isId(p.id) && typeof p.key === 'string' && Number.isSafeInteger(p.seq) && p.seq > 0 && Number.isFinite(p.offset) && Number.isFinite(p.savedAt) && (p.activity === null || typeof p.activity === 'string')));
  } catch { return {}; }
}
export function readingPosition(accountId: string, conversationId: string) { return load(accountId)[conversationId]; }
export function rememberPosition(accountId: string, conversationId: string, position: ReadingPosition | null) {
  const positions = load(accountId);
  delete positions[conversationId];
  const now = Date.now();
  for (const [id, p] of Object.entries(positions)) if (now < p.savedAt || now - p.savedAt >= 1_800_000) delete positions[id];
  if (position) positions[conversationId] = position;
  try { localStorage.setItem(key(accountId), JSON.stringify(Object.fromEntries(Object.entries(positions).slice(-100)))); } catch { /* Storage denial never blocks the conversation. */ }
}
export function forgetPositions(accountId: string) { try { localStorage.removeItem(key(accountId)); } catch { /* Unavailable storage has no retained positions. */ } }
